import styles from './styles.module.scss';

// Hand-placed star patterns (viewBox 120x80) — [x, y] points joined in order.
const PATTERNS = [
    [
        [8, 62],
        [30, 48],
        [46, 54],
        [66, 30],
        [88, 36],
        [108, 12]
    ],
    [
        [10, 20],
        [34, 34],
        [58, 26],
        [74, 52],
        [98, 60],
        [112, 40]
    ],
    [
        [14, 66],
        [36, 44],
        [52, 60],
        [78, 42],
        [92, 18],
        [110, 30]
    ]
];

/** Decorative constellation for a life-theme card; `seed` picks the pattern. */
const ConstellationArt = ({ seed = 0 }) => {
    const points = PATTERNS[Math.abs(seed) % PATTERNS.length];
    return (
        <svg className={styles.constellation} viewBox="0 0 120 80" aria-hidden="true" focusable="false">
            <polyline className={styles.constellationLine} points={points.map((p) => p.join(',')).join(' ')} />
            {points.map(([x, y], index) => (
                <circle key={index} className={styles.constellationStar} cx={x} cy={y} r={index % 2 ? 1.6 : 2.4} />
            ))}
        </svg>
    );
};

export default ConstellationArt;
